var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0234 12.2334C24.5628 12.2334 25 11.7962 25 11.2568V4.86035C25 2.70645 23.2477 0.954102 21.0938 0.954102H3.90625C1.75234 0.954102 0 2.70645 0 4.86035V16.1396C0 18.2936 1.75234 20.0459 3.90625 20.0459H21.0938C23.2477 20.0459 25 18.2936 25 16.1396C25 15.6003 24.5628 15.1631 24.0234 15.1631C23.4841 15.1631 23.0469 15.6003 23.0469 16.1396C23.0469 17.2166 22.1707 18.0928 21.0938 18.0928H3.90625C2.8293 18.0928 1.95312 17.2166 1.95312 16.1396V5.06729L10.4373 10.3429C11.0734 10.7385 11.7867 10.9363 12.5 10.9363C13.2133 10.9363 13.9266 10.7385 14.5627 10.3429L23.0469 5.06729V11.2568C23.0469 11.7962 23.4841 12.2334 24.0234 12.2334ZM13.5313 8.68428C12.8952 9.07983 12.1048 9.07988 11.4687 8.68428L2.76802 3.27402C3.08872 3.04326 3.48188 2.90723 3.90625 2.90723H21.0938C21.5181 2.90723 21.9113 3.04331 22.232 3.27407L13.5313 8.68428Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.1963b36b2ab3fea14c037bdf9077260b.svg";
export { ForwardRef as ReactComponent };